import apiRequest from './apiRequest';

const businesInformationApi = {
    async createBusinesInformation(accountId, bankData, token) {
        const url = `/api/accounts/business-information?accountId=${accountId}`;
        return apiRequest(url, 'POST', token, bankData);
    },

    async getBusinesInformation(accountId, token) {
        const url = `/api/accounts/business-information?accountId=${accountId}`;
        return apiRequest(url, 'GET', token);
    },

    async updateBusinesInformation(accountId, bankData, token) {
        const url = `/api/accounts/business-information?accountId=${accountId}`;
        return apiRequest(url, 'PUT', token, bankData);
    },
};

export default businesInformationApi;
